import { render, staticRenderFns } from "./taxRateEditDialog.vue?vue&type=template&id=64a2c8d7&"
import script from "./taxRateEditDialog.vue?vue&type=script&lang=js&"
export * from "./taxRateEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports